import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { AiOutlineUserDelete } from "react-icons/ai";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import { BsDash } from "react-icons/bs";
import dayjs from "dayjs";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import OptimizedUserList1 from "../../components/ui/OptimizedUserList1";
import { useNavigate } from "react-router-dom";
import utc from 'dayjs/plugin/utc'
import { AiFillEdit } from "react-icons/ai";
import { API_URL } from "../../config";
import { logAuditUI } from "../../utils/auditLogger";

dayjs.extend(utc);
dayjs.tz.guess();

function DashboardCard24copy() {
  const { showToast } = useToast();
  const navigate = useNavigate();

  const location = useLocation();
  const { item: initialData } = location.state || {};
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [reportdata, setreportData] = useState([]);
  const [reportdataday, setreportDataday] = useState([]);
  const [data, setData] = useState([]);
  const [Manage1, setManage1] = useState([]);
  const [specData, setspecData] = useState([]);
  const [instData, setinstData] = useState([]);
  const [userinstData, setUserinstData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsers1, setSelectedUsers1] = useState([]);
  const [Manage, setManage] = useState([]);
  const [city, setCity] = useState([]);
  const [filinstcity, setfilinstCity] = useState([]);
  const [instcity, setinstCity] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQuery1, setSearchQuery1] = useState('');
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showGrid, setShowGrid] = useState(true);
  const [Data1, setData1] = useState([]);
  const [Data2, setData2] = useState([]);
  const [Data3, setData3] = useState([]);
  const [Data4, setData4] = useState([]);
  const [Data5, setData5] = useState([]);
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [defaultOption, setDefaultOption] = useState("");
  const [selectedUsers2, setSelectedUsers2] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [product, setProduct] = useState([]);
  const [coment, setComent] = useState('');
  const [searchQuery2, setSearchQuery2] = useState('');
  const [openRow, setOpenRow] = useState(null);
  const [openRow1, setOpenRow1] = useState(null);
  const [openRow2, setOpenRow2] = useState(null);
  const [openRow3, setOpenRow3] = useState(null);
  const [selecteddeleteuser1, setSelecteddeleteuser1] = useState(null);
  const [selecteddeleteuser2, setSelecteddeleteuser2] = useState(null);
  const [selecteddeleteuser3, setSelecteddeleteuser3] = useState(null);
  const [selecteddeleteuser4, setSelecteddeleteuser4] = useState(null);
  const [selecteddeleteuser5, setSelecteddeleteuser5] = useState(null);
  const getCurrentTime = () => dayjs().hour(8).minute(30).second(0).millisecond(0).format();
  const [startTime, setStartTime] = useState(getCurrentTime());
  const [endTime, setEndTime] = useState(getCurrentTime());
  const [defaultOption1, setDefaultOption1] = useState([]);
  const [defaultOption2, setDefaultOption2] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
        //  //////////////////////////////console.log(Login)

      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
    logAuditUI({
      module: 'Raportare',
      action: 'OPEN_FORM',
      entityId: initialData?.report_id || null,
      details: `Deschidere formular copiere raportare (ID: ${initialData?.report_id || ''})`
    });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/report`)
      .then((response) => {
        const filter = response.data.find((i) => i.report_id === selectedEditRowData.report_id);
        setreportData(filter);
        setDefaultOption(selectedEditRowData.user_id);
        const formattedDatestart = dayjs.utc(filter.date).format("YYYY-MM-DD");
        setStartDate(formattedDatestart);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/reportdetail`)
      .then((response) => {
        const filter = response.data.filter((i) => i.report_id === reportdata.report_id);

        setData2((prevData) => {
          const uniqueReportIds = [...new Set([...prevData.map((item) => item.report_id), ...filter.map((item) => item.report_id)])];

          const reportIdToIndex = uniqueReportIds.reduce((acc, id, index) => {
            acc[id] = index;
            return acc;
          }, {});

          const newEntries = filter.map((item, idx) => ({
            id: reportIdToIndex[item.report_id],
            report_id: item.report_id,
            obiect_id: item.object_id,
            obiect_type_id: item.obiect_type_id,
            is_active: item.is_active,
            start_time: item.start_time,
            end_time: item.end_time,
            index: idx + 1, // Index începe de la 1 și crește pentru fiecare item
            comment: item.comment,
            report_detail_id: item.report_detail_id
          }));

          return [...prevData, ...newEntries];
        });
        setreportDataday(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [reportdata]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/reportproducts`)
      .then((response) => {
        const filter1 = reportdataday
          .filter((i) => i.report_id === reportdata.report_id)
          .map((i) => i.report_detail_id);

        const filter = response.data.filter((i) => filter1.includes(i.report_detail_id));

        const updatedFilter = filter.map((item) => {
          const index = filter1.indexOf(item.report_detail_id) + 1;
          return {
            product_id: item.product_id,
            index: index,
          };
        });

        setData4((prevData) => {
          const uniqueData = [...prevData, ...updatedFilter].reduce((acc, current) => {
            if (!acc.some((item) => item.product_id === current.product_id && item.index === current.index)) {
              acc.push(current);
            }
            return acc;
          }, []);
          return uniqueData;
        });
      })
      .catch((error) => {
        console.error("Error fetching report products:", error);
      });
  }, [reportdataday]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/reportmaterials`)
      .then((response) => {
        const filter1 = reportdataday
          .filter((i) => i.report_id === reportdata.report_id)
          .map((i) => i.report_detail_id);

        const filter = response.data.filter((i) => filter1.includes(i.report_detail_id));

        const updatedFilter = filter.map((item) => {
          const index = filter1.indexOf(item.report_detail_id) + 1;
          return {
            materials_id: item.materials_id,
            index: index,
          };
        });

        setData3((prevData) => {
          const uniqueData = [...prevData, ...updatedFilter].reduce((acc, current) => {
            if (!acc.some((item) => item.materials_id === current.materials_id && item.index === current.index)) {
              acc.push(current);
            }
            return acc;
          }, []);
          return uniqueData;
        });
      })
      .catch((error) => {
        console.error("Error fetching report products:", error);
      });
  }, [reportdataday]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/reportdoublevisits`)
      .then((response) => {
        const filter1 = reportdataday
          .filter((i) => i.report_id === reportdata.report_id)
          .map((i) => i.report_detail_id);

        const filter = response.data.filter((i) => filter1.includes(i.report_detail_id));

        const updatedFilter = filter.map((item) => {
          const index = filter1.indexOf(item.report_detail_id) + 1;
          return {
            user_id: item.user_id,
            index: index,
          };
        });

        setData5((prevData) => {
          const uniqueData = [...prevData, ...updatedFilter].reduce((acc, current) => {
            if (!acc.some((item) => item.user_id === current.user_id && item.index === current.index)) {
              acc.push(current);
            }
            return acc;
          }, []);
          return uniqueData;
        });
      })
      .catch((error) => {
        console.error("Error fetching report products:", error);
      });
  }, [reportdataday]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/materials`)
      .then((response) => {
        const data = response.data.filter((i) => i.is_active !== 0)
        setMaterials(data)
        // //////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/usersproducersacces`)
      .then((response) => {
        const data = response.data.filter((i) => i.user_id === user?.userId).map((i) => i.producer_or_producer_group_id)
        //////////////////////////console.log(data)
        if (data) {
          axios
            .get(`${API_URL}/api/product`)
            .then((response) => {
              const data1 = response.data.filter((i) => i.is_active !== 0 && data.includes(i.producer_id))
              setProduct(data1)
              //////////////////////////console.log(data1)
            })
            .catch((error) => {
              console.error("Error fetching user data:", error);

            });
        } else {
          setProduct([])
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, [user]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/speciality`)
      .then((response) => {
        setspecData(response.data)
        ////////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/physiciansinstitute`)
      .then((response) => {
        setUserinstData(response.data)
        ////////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/institutions`)
      .then((response) => {
        setinstData(response.data)
        //   //////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adressinstitutions`)
      .then((response) => {
        const item = response.data.filter((i) => i.institute_type_id === 2);
        setfilinstCity(item);
        setinstCity(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adress`)
      .then((response) => {
        setCity(response.data)
        // ////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  const fetchManageData = () => {
    axios
      .get(`${API_URL}/api/usersphysicians`)
      .then((response) => {
        //////////////////////////console.log(defaultOption)
        const users = response.data.filter(
          (item) => item.user_id == defaultOption
        );

        if (users.length > 0) {
          const subordinateUserId = users.map((item) => item.physician_id);

          axios
            .get(`${API_URL}/api/physician`)
            .then((response) => {
              // //////////////////////////////console.log('Fetched users:', response.data);

              const users = response.data.filter((item) =>
                subordinateUserId.includes(item.physician_id)
              );

              // //////////////////////////////console.log('Fetched users:', users);

              setData(users);
            })
            .catch((error) => {
              console.error("Error fetching users data:", error);
            });
        } else {
          setData([])
        }
      })
      .catch((error) => {
        console.error("Error fetching manage data:", error);
      });
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/api/physician`)
      .then((response) => {
        const uniqueManageData = response.data;
        fetchManageData();
        setManage1(uniqueManageData);
      })
      .catch((error) => {
        console.error("Error fetching users data:", error);
      });
  }, [selectedEditRowData]);

  useEffect(() => {
    const selectProducerIds = data.map((item) => item.physician_id);
    const select = userinstData.filter((item) => selectProducerIds.includes(item.physician_id));
    setManage(select);
  }, [data, searchQuery]);

  useEffect(() => {
    ////////////////////////console.log("Data2 updated:", Data2);
    ////////////////////////console.log("Data2 updated:", Data3);
    ////////////////////////console.log("Data2 updated:", Data4);

  }, [Data2, Data3, Data4]);

  useEffect(() => {
    if (selecteddeleteuser) {
      deleteRowuser();
    }
  }, [selecteddeleteuser]);

  // useEffect(() => {
  //   axios
  //     .get(`${API_URL}/api/manageuser")
  //     .then((response) => {
  //       const users = response.data.filter(
  //         (item) => item.manager_user_id === user?.userId
  //       );
  //       if (users.length > 0) {
  //         const subordinateUserId = users.map((item) => item.subordinate_user_id);

  //         axios
  //           .get(`${API_URL}/api/users")
  //           .then((response) => {
  //             const users = response.data.filter((item) =>
  //               subordinateUserId.includes(item.user_id) || item.user_id === user.userId
  //             );

  //             if (user && user.role === 'Admin') {
  //               setData1(response.data);
  //               // //////////////////////////////console.log(response.data)
  //             } else {
  //               ////////////////////////////////////console.log('Fetched users:', users);
  //               setData1(users);
  //             }
  //           })
  //           .catch((error) => {
  //             console.error("Error fetching users data:", error);
  //           });
  //       } else {
  //         setData1([])
  //       }
  //     }
  //     )
  //     .catch((error) => {
  //       console.error("Error fetching manage data:", error);
  //     });
  // }, [user]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/manageuser`)
      .then((response) => {
        const users = response.data.filter(
          (item) => item.manager_user_id === user?.userId
        );
        if (users.length > 0) {
          const subordinateUserId = users.map((item) => item.subordinate_user_id);

          axios
            .get(`${API_URL}/api/users`)
            .then((response) => {
              const users = response.data.filter((item) =>
                subordinateUserId.includes(item.user_id) || item.user_id === user.userId
              );

              if (user && user.role === 'Admin') {
                setData1(response.data);
                // //////////////////////////////console.log(response.data)
              } else {
                ////////////////////////////////////console.log('Fetched users:', users);
                setData1(users);
              }
            })
            .catch((error) => {
              console.error("Error fetching users data:", error);
            });
        } else {
          const use = response.data.find((i) => i.subordinate_user_id === user?.userId);
          ////////////////////console.log(use)
          if (use) {
            const subordinateUserId = use.manager_user_id;
            const users1 = response.data.filter(
              (item) => item.manager_user_id === subordinateUserId
            ).map((item) => item.subordinate_user_id);
            ////////////////////console.log(users1)
            axios
              .get(`${API_URL}/api/users`)
              .then((response) => {
                const users2 = response.data.filter((item) =>
                  users1.includes(item.user_id)
                );
                ////////////////////console.log(users2)
                setData1(users2);  // Non-admin fetches only relevant users
              })
              .catch((error) => {
                console.error("Error fetching users data:", error);
              });
          } else {
            setData1([]);  // No subordinate user found
          }
        }
      }
      )
      .catch((error) => {
        console.error("Error fetching manage data:", error);
      });
  }, [user]);

  useEffect(() => {
    if (selecteddeleteuser1) {
      handleOpenRows2();
    }
  }, [selecteddeleteuser1]);

  useEffect(() => {
    if (selecteddeleteuser2) {
      handleOpenRows3();
    }
  }, [selecteddeleteuser2]);

  useEffect(() => {
    if (selecteddeleteuser3) {
      handleOpenRows4();
    }
  }, [selecteddeleteuser3]);

  useEffect(() => {
    if (selecteddeleteuser4) {
      handleOpenRows5();
    }
  }, [selecteddeleteuser4]);

  useEffect(() => {
    if (selecteddeleteuser5) {
      handleOpenRows6();
    }
  }, [selecteddeleteuser5]);

  const handleOpenRows = () => {
    setOpen(true);
  };

  const handleToggleUser = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleOpenRows1 = () => {
    setOpen1(true);
  };

  const handleToggleUser1 = (userId) => {
    setSelectedUsers1((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleOpenRows2 = () => {
    setOpen2(true);
    ////////////////////console.log(selecteddeleteuser1)
    const startTimeFormatted = dayjs.utc(selecteddeleteuser1.start_time);
    const endTimeFormatted = dayjs.utc(selecteddeleteuser1.end_time);
    ////////////////////console.log(startTimeFormatted)
    ////////////////////console.log(endTimeFormatted)
    setStartTime(startTimeFormatted);
    setEndTime(endTimeFormatted);
  };

  const handleOpenRows3 = () => {
    setOpen3(true);
    setComent(selecteddeleteuser2.comment)
    //////////////////////////console.log(selecteddeleteuser2)
  };

  const handleOpenRows4 = () => {
    setOpen4(true);
    //////////////////////////console.log(selecteddeleteuser3)
  };

  const handleOpenRows5 = () => {
    setOpen5(true);
    //////////////////////////console.log(selecteddeleteuser4)
  };

  const handleOpenRows6 = () => {
    setOpen6(true);
    //////////////////////////console.log(selecteddeleteuser4)
    // //////////////////////console.log(dropdownOptions)
  };

  const handleToggleUser2 = (userId) => {
    setSelectedUsers2((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleSave = async () => {
    if (!selectedUsers || !Array.isArray(selectedUsers) || selectedUsers.length === 0) {
      showToast({
        message: "Selectează cel puțin un medic!",
        type: "warning",
        icon: <FaRegTimesCircle className="text-yellow-600 dark:text-yellow-500" />,
      });
      return;
    }
    ////////////////////////console.log(selectedUsers)
    setData2((prevData) => {
      const newEntries = selectedUsers.map((physicianId, index) => {
        const startOffset = (prevData.length + index) * 20;
        const endOffset = startOffset + 20;
        ////////////////////////console.log(prevData.start_time)
        const newStartTime = new Date(prevData.start_time ? prevData.start_time : startTime);
        newStartTime.setMinutes(newStartTime.getMinutes() + startOffset);

        const newEndTime = new Date(prevData.end_time ? prevData.end_time : endTime);
        newEndTime.setMinutes(newEndTime.getMinutes() + endOffset);

        return {
          start_time: newStartTime, // Convertește într-un string ISO
          end_time: newEndTime,
          obiect_id: physicianId,
          index: prevData.length + index + 1,
          obiect_type_id: 1,
          comment: ""
        };
      });

      return [...prevData, ...newEntries];
    });

    setSelectedUsers("");
    setOpen(false);
  };

  const handleButtonClick = async () => {
    setIsLoading(true);
    try {
      await handleSave();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave1 = async () => {
    if (!selectedUsers1 || !Array.isArray(selectedUsers1) || selectedUsers1.length === 0) {
      showToast({
        message: "Selectează cel puțin o institutie!",
        type: "warning",
        icon: <FaRegTimesCircle className="text-yellow-600 dark:text-yellow-500" />,
      });
      return;
    }

    setData2((prevData) => {
      const newEntries = selectedUsers1.map((physicianId, index) => {
        const startOffset = (prevData.length + index) * 20;
        const endOffset = startOffset + 20;

        const newStartTime = new Date(startTime);
        newStartTime.setMinutes(newStartTime.getMinutes() + startOffset);

        const newEndTime = new Date(endTime);
        newEndTime.setMinutes(newEndTime.getMinutes() + endOffset);

        return {
          start_time: newStartTime,
          end_time: newEndTime,
          obiect_id: physicianId,
          index: prevData.length + index + 1,
          obiect_type_id: 2,
          comment: ""
        };
      });

      return [...prevData, ...newEntries];
    });

    setSelectedUsers1("");
    setOpen1(false);
  };

  const handleButtonClick1 = async () => {
    setIsLoading(true);
    try {
      await handleSave1();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave2 = async () => {
    setData2((prevData) => {
      const updatedData = prevData.map((entry) => {
        if (entry.index === selecteddeleteuser1.index) {
          const newStartTime = startTime;
          const newEndTime = endTime;

          return {
            ...entry,
            start_time: newStartTime,
            end_time: newEndTime,
          };
        }
        return entry;
      });
      return updatedData;
    });

    setSelecteddeleteuser1("");
    setOpen2(false);
  };

  const handleButtonClick2 = async () => {
    setIsLoading(true);
    try {
      await handleSave2();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave3 = async () => {
    setData2((prevData) => {
      const updatedData = prevData.map((entry) => {
        if (entry.index === selecteddeleteuser2.index) {
          return {
            ...entry,
            comment: coment
          };
        }
        return entry;
      });
      //////////////////////////console.log(updatedData)
      return updatedData;
    });
    setComent("")
    setSelecteddeleteuser2("");
    setOpen3(false);
  };

  const handleButtonClick3 = async () => {
    setIsLoading(true);
    try {
      await handleSave3();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave4 = async () => {
    //////////////////////////console.log(selecteddeleteuser3)
    setData3((prevData) => {
      const safeDefaultOption = Array.isArray(defaultOption1) ? defaultOption1 : [];

      const newEntries = safeDefaultOption.map((id) => {
        return {
          materials_id: id,
          index: selecteddeleteuser3.index
        };
      });

      return [...prevData, ...newEntries];
    });
    setSelecteddeleteuser2("");
    setOpen4(false);
  };

  const handleButtonClick4 = async () => {
    setIsLoading(true);
    try {
      await handleSave4();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave5 = async () => {
    //////////////////////////console.log(selecteddeleteuser4)
    setData4((prevData) => {
      const newEntries = selectedUsers2.map((id) => {
        return {
          product_id: id,
          index: selecteddeleteuser4.index
        };
      });

      return [...prevData, ...newEntries];
    });
    setSelecteddeleteuser2("");
    setOpen5(false);
  };

  const handleButtonClick5 = async () => {
    setIsLoading(true);
    try {
      await handleSave5();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave6 = async () => {
    //////////////////////console.log(selecteddeleteuser4)
    setData5((prevData) => {
      const safeDefaultOption = Array.isArray(defaultOption2) ? defaultOption2 : [];


      const newEntries = safeDefaultOption.map((id) => {
        return {
          user_id: id,
          index: selecteddeleteuser5.index
        };
      });

      return [...prevData, ...newEntries];
    });
    setSelecteddeleteuser2("");
    setOpen6(false);
  };

  const handleButtonClick6 = async () => {
    setIsLoading(true);
    try {
      await handleSave6();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteRowuser = async () => {
    if (!selecteddeleteuser) return;
    // //////////////////////////////console.log(selecteddeleteuser)
    setData2((prevData) => {
      const filteredData = prevData.filter(
        (item) => item.id !== selecteddeleteuser.id || item.obiect_id !== selecteddeleteuser.obiect_id
      );
      return filteredData;
    });
  };

  const handleSubmit = async (e) => {
    try {
      setLoading(true);

      const response = await axios.post(`${API_URL}/api/report`, {
        user_id: defaultOption || user.userId,
        date: startDate,
        submited_user_id: user.userId,
      });

      const lastPlanningId = response.data.report_id;

      const requests = Data2
        .filter(({ obiect_type_id }) => obiect_type_id != null)
        .map(({ start_time, end_time, comment, obiect_type_id, obiect_id }) => ({
          report_id: lastPlanningId,
          start_time,
          end_time,
          comment,
          obiect_type_id,
          object_id: obiect_id,
          is_double_visit: 1,
          planning_id: selectedEditRowData.planning_id,
          user_id: user?.userId
        }));

      if (requests.length === 0) return handleSuccess();

      const rep = await axios.post(`${API_URL}/api/reportdetail`, requests);
      const reportDetailIds = rep.data.report_detail_ids;

      const requests1 = reportDetailIds.flatMap((report_detail_id, index) =>
        Data3.filter(d => d.index === index + 1).map(({ materials_id }) => ({
          materials_id,
          report_detail_id,
          is_active: 1,
          user_id: user?.userId,
          planning_id: selectedEditRowData.planning_id

        }))
      );

      const requests2 = reportDetailIds.flatMap((report_detail_id, index) =>
        Data4.filter(d => d.index === index + 1).map(({ product_id }) => ({
          product_id,
          report_detail_id,
          is_active: 1,
        }))
      );

      const requests3 = reportDetailIds.flatMap((report_detail_id, index) =>
        Data5.filter(d => d.index === index + 1).map(({ user_id }) => ({
          user_id,
          report_detail_id,
          is_active: 1,
        }))
      );

      await Promise.all([
        requests1.length > 0 && axios.post(`${API_URL}/api/reportmaterials`, requests1),
        requests2.length > 0 && axios.post(`${API_URL}/api/reportproducts`, requests2),
        requests3.length > 0 && axios.post(`${API_URL}/api/reportdoublevisits`, requests3),
      ]);

      handleSuccess();
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
      fetch(`${API_URL}/api/send-error`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          error: error.message,
          stack: error.stack,
          componentStack: `DashbordCard24copy | UserID: ${user?.userId}`,
        }),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    handleClose();
    showToast({
      message: "Datele au fost salvate cu succes!",
      type: "success",
      icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
    });
  };

  const handleClose = () => {
    navigate(-1);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const itemsPerPage1 = 10;
  const [currentPage1, setCurrentPage1] = useState(1);
  const totalPages1 = Math.ceil(Data2.length / itemsPerPage1);
  const currentItems1 = Data2.slice(
    (currentPage1 - 1) * itemsPerPage1,
    currentPage1 * itemsPerPage1
  );

  const dropdownOptions = Data1.map((region) => ({
    value: region.user_id,
    label: region.user_name_surname
  }));

  const _onSelect = (selectedOption) => {
    ////////////////////////////////////console.log(selectedOption);
    setDefaultOption(selectedOption);
  };

  const dropdownOptions1 = materials.map((region) => ({
    value: region.materials_id,
    label: region.description
  }));

  const _onSelect1 = (value, isChecked) => {
    if (isChecked) {
      setDefaultOption1((prev) => [...prev, value]);
    } else {
      setDefaultOption1((prev) => prev.filter((item) => item !== value));
    }
  };

  const _onSelect2 = (value, isChecked) => {
    if (isChecked) {
      setDefaultOption2((prev) => [...prev, value]);
    } else {
      setDefaultOption2((prev) => prev.filter((item) => item !== value));
    }
  };

  const handleStartTimeChange = (e) => {
    const selectedTime = e.target.value;
    const currentDate = dayjs().format("YYYY-MM-DD");

    const formattedTime = dayjs.utc(`${currentDate}T${selectedTime}`).format();

    setStartTime(formattedTime);
  };

  const handleEndTimeChange = (e) => {
    const selectedTime = e.target.value;
    const currentDate = dayjs().format("YYYY-MM-DD");

    const formattedTime = dayjs.utc(`${currentDate}T${selectedTime}`).format();

    setEndTime(formattedTime);
  };

  const handleChangecom = (event) => {
    setComent(event.target.value);
  };

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
              <CardHeader subheader="Informatia poate fii modificata" title="Formular" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                action={
                  user.role !== 'User' && (
                    <div className="relative mt-4">
                      <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">User</label>
                      <select
                        className="w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                        //  style={{ width: '300px' }}
                        value={defaultOption}
                        onChange={(e) => _onSelect(e.target.value)}
                      >
                        <option value="" disabled>Alege user</option>
                        {dropdownOptions.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                  )
                }
              />
              <Divider className="dark:bg-gray-400" />
              <CardContent>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div className="flex gap-2">
                    <div className="relative w-full">
                      <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                        Data
                      </label>
                      <input
                        className="w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                        type="date"
                        name="startDate"
                        placeholder="Început"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="relative mt-4">
                  <Divider className="dark:bg-gray-400" />
                  <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800 dark:text-gray-100">Raportae detalii</h2>
                    <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto">
                      <>
                        <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                          onClick={handleOpenRows1}
                        >
                          <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                          </svg>
                          <span className="//max-xs:sr-only">Adauga Farmacia</span>

                          <Transition appear show={open1} as={Fragment}>
                            <Dialog as="div" className="relative z-10" onClose={() => setOpen1(false)}>
                              <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <div className="fixed inset-0 bg-black bg-opacity-25" />
                              </Transition.Child>

                              <div className="fixed inset-0 overflow-y-auto">
                                <div className="flex min-h-full items-center justify-center p-4 text-center">
                                  <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                  >
                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                      <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                        Selectează Institutia
                                      </Dialog.Title>
                                      <div className="mt-4">
                                        <input
                                          type="text"
                                          className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                                          placeholder="Căutare Institutia"
                                          value={searchQuery1}
                                          onChange={(e) => setSearchQuery1(e.target.value)} />
                                      </div>

                                      <div className="mt-4 max-h-64 overflow-y-auto">
                                        <ul>
                                          {filinstcity.filter((user) => {
                                            const matchingInstCity = instcity.find((i) => i.id === user.id);
                                            const cityName = matchingInstCity ? city.find((i) => i.adress_id === matchingInstCity.adress_id)?.city_name : null;

                                            return (
                                              user.inst.toLowerCase().includes(searchQuery1.toLowerCase()) ||
                                              user.adres.toLowerCase().includes(searchQuery1.toLowerCase()) ||
                                              (cityName && cityName.toLowerCase().includes(searchQuery1.toLowerCase()))
                                            );
                                          }).map((user) => {
                                            return (
                                              <li key={user.id} className="flex items-center gap-2 p-2 border-b">
                                                <input
                                                  type="checkbox"
                                                  className="h-4 w-4"
                                                  checked={selectedUsers1.includes(user.id)}
                                                  onChange={() => handleToggleUser1(user.id, "physician")} />
                                                <div>
                                                  <div className="pl-4 flex items-center justify-between">
                                                    <h3 className="text-gray-900">{user.inst}</h3>
                                                  </div>
                                                  <div className="text-sm text-gray-500 ml-4">
                                                    {user.adres} - {
                                                      (() => {
                                                        const matchingInstCity = instcity.find((i) => i.id === user.id);
                                                        if (!matchingInstCity) return null;
                                                        const matchingCity1 = city.find((i) => i.adress_id === matchingInstCity.adress_id);

                                                        return matchingCity1 ? matchingCity1.city_name : null;
                                                      })()
                                                    }
                                                  </div>
                                                </div>
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      </div>

                                      <div className="mt-4 flex justify-end gap-2">
                                        <button
                                          className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                          onClick={() => setOpen1(false)}
                                        >
                                          Anulează
                                        </button>

                                        <button
                                          className={`btn ${isLoading
                                            ? "bg-gray-500 text-gray-300"
                                            : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                          onClick={handleButtonClick1}
                                          disabled={isLoading}
                                        >
                                          {isLoading ? (
                                            <svg
                                              className="animate-spin fill-current shrink-0 xs:hidden"
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                            >
                                              <circle
                                                className="opacity-25"
                                                cx="8"
                                                cy="8"
                                                r="7"
                                                stroke="currentColor"
                                                strokeWidth="2" />
                                              <path
                                                className="opacity-75"
                                                d="M12 2a6 6 0 000 12V2z" />
                                            </svg>
                                          ) : (
                                            <svg
                                              className="fill-current shrink-0 xs:hidden"
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                            </svg>
                                          )}
                                          <span className="//max-xs:sr-only">
                                            {isLoading ? "Saving..." : "Salveaza detaliile"}
                                          </span>
                                        </button>
                                      </div>
                                    </Dialog.Panel>
                                  </Transition.Child>
                                </div>
                              </div>
                            </Dialog>
                          </Transition>
                        </button>

                        <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                          onClick={handleOpenRows}
                        >
                          <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                          </svg>
                          <span className="//max-xs:sr-only">Adauga Doctor</span>

                          <Transition appear show={open} as={Fragment}>
                            <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
                              <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <div className="fixed inset-0 bg-black bg-opacity-25" />
                              </Transition.Child>

                              <div className="fixed inset-0 overflow-y-auto">
                                <div className="flex min-h-full items-center justify-center p-4 text-center">
                                  <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                  >
                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                      <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                        Selectează doctor
                                      </Dialog.Title>
                                      <div className="mt-4">
                                        <input
                                          type="text"
                                          className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                                          placeholder="Căutare doctor"
                                          value={searchQuery}
                                          onChange={(e) => setSearchQuery(e.target.value)} />
                                      </div>

                                      <OptimizedUserList1
                                        // Manage={Manage}
                                        Manage={userinstData}
                                        searchQuery={searchQuery}
                                        selectedUsers={selectedUsers}
                                        handleToggleUser={handleToggleUser}
                                        userinstData={userinstData}
                                        userspecData={userinstData}
                                        specData={specData}
                                        instData={instData}
                                      />

                                      <div className="mt-4 flex justify-end gap-2">
                                        <button
                                          className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                          onClick={() => setOpen(false)}
                                        >
                                          Anulează
                                        </button>

                                        <button
                                          className={`btn ${isLoading
                                            ? "bg-gray-500 text-gray-300"
                                            : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                          onClick={handleButtonClick}
                                          disabled={isLoading}
                                        >
                                          {isLoading ? (
                                            <svg
                                              className="animate-spin fill-current shrink-0 xs:hidden"
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                            >
                                              <circle
                                                className="opacity-25"
                                                cx="8"
                                                cy="8"
                                                r="7"
                                                stroke="currentColor"
                                                strokeWidth="2" />
                                              <path
                                                className="opacity-75"
                                                d="M12 2a6 6 0 000 12V2z" />
                                            </svg>
                                          ) : (
                                            <svg
                                              className="fill-current shrink-0 xs:hidden"
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                            </svg>
                                          )}
                                          <span className="//max-xs:sr-only">
                                            {isLoading ? "Saving..." : "Salveaza detaliile"}
                                          </span>
                                        </button>
                                      </div>
                                    </Dialog.Panel>
                                  </Transition.Child>
                                </div>
                              </div>
                            </Dialog>
                          </Transition>
                        </button>
                      </>
                    </div>
                  </header>

                  <div className="p-3" >
                    <div className="lg:flex w-full">
                      <div className="w-full overflow-x-auto">
                        <table className="w-full table-auto whitespace-nowrap">
                          <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                            <tr>
                              <th className="p-2">
                                <div className="font-semibold text-left">Interval ora</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Doctor</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Specialitatea</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Institutia</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Adresa</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Oras</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Comentariu</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Materiale</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Produse</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Vizita Dubla</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Actiune</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                            {currentItems1.map((item, idx) => {
                              const userInst = userinstData?.find((i) => i.institute_assign_id === item.obiect_id) || {};
                              const instCity = instcity?.find((i) => i.id === item.obiect_id) || {};
                              const cityData = city?.find((i) => instcity?.some((inst) => inst.id === item.obiect_id && inst.adress_id === i.adress_id)) || {};
                              const userAdres = instcity?.find((i) => i.id === userInst.institution_in_adress_id) || {};
                              const userCity = city?.find((i) => i.adress_id === userAdres.adress_id) || {};

                              return (
                                <React.Fragment key={idx}>
                                  <tr className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                    <td className="p-2 whitespace-nowrap flex items-center">
                                      {item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                        ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                          <span>{item.start_time} - {item.end_time}</span>)}
                                      <div
                                        className="font-semibold text-center"
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "20px",
                                        }}
                                      >
                                        <Tooltip title="Editeaza" arrow placement="top">
                                          <IconButton
                                            onClick={() => setSelecteddeleteuser1(item)}
                                            color="primary"
                                            sx={{
                                              fontSize: "16px",
                                              borderRadius: "50%",
                                              "&:hover": {
                                                backgroundColor: "#a4adad",
                                              },
                                            }}
                                          >
                                            <AiFillEdit className="dark:text-gray-100" />
                                            <Transition appear show={open2} as={Fragment}>
                                              <Dialog as="div" className="relative z-10" onClose={() => setOpen2(false)}>
                                                <Transition.Child
                                                  as={Fragment}
                                                  enter="ease-out duration-300"
                                                  enterFrom="opacity-0"
                                                  enterTo="opacity-100"
                                                  leave="ease-in duration-200"
                                                  leaveFrom="opacity-100"
                                                  leaveTo="opacity-0"
                                                >
                                                  <div className="fixed inset-0 bg-black bg-opacity-25" />
                                                </Transition.Child>

                                                <div className="fixed inset-0 overflow-y-auto">
                                                  <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                    <Transition.Child
                                                      as={Fragment}
                                                      enter="ease-out duration-300"
                                                      enterFrom="opacity-0 scale-95"
                                                      enterTo="opacity-100 scale-100"
                                                      leave="ease-in duration-200"
                                                      leaveFrom="opacity-100 scale-100"
                                                      leaveTo="opacity-0 scale-95"
                                                    >
                                                      <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                        <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                                          Selectează Ora
                                                        </Dialog.Title>
                                                        <div className="mt-4">
                                                          <form className="max-w-[16rem] mx-auto grid grid-cols-2 gap-4">
                                                            <div>
                                                              <label htmlFor="start-time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                                Start ora:
                                                              </label>
                                                              <div className="relative">
                                                                <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                                                                  <svg
                                                                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                    aria-hidden="true"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    fill="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                  >
                                                                    <path
                                                                      fillRule="evenodd"
                                                                      // d="2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10Zm1 7V8h-2v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V9Z"
                                                                      clipRule="evenodd"
                                                                    />
                                                                  </svg>
                                                                </div>
                                                                <input
                                                                  type="time"
                                                                  id="start-time"
                                                                  className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                  // value={startTime}
                                                                  value={startTime ? dayjs.utc(startTime, "HH:mm").format("HH:mm") : ""}
                                                                  onChange={handleStartTimeChange}
                                                                  name="appt" min="09:00" max="18:00" // Actualizează valoarea start time
                                                                  required
                                                                />
                                                              </div>
                                                            </div>
                                                            <div>
                                                              <label htmlFor="end-time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                                End ora:
                                                              </label>
                                                              <div className="relative">
                                                                <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                                                                  <svg
                                                                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                    aria-hidden="true"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    fill="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                  >
                                                                    <path
                                                                      fillRule="evenodd"
                                                                      // d="2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10Zm1 7V8h-2v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V9Z"
                                                                      clipRule="evenodd"
                                                                    />
                                                                  </svg>
                                                                </div>
                                                                <input
                                                                  type="time"
                                                                  id="end-time"
                                                                  className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                  // value={endTime}
                                                                  value={endTime ? dayjs.utc(endTime, "HH:mm").format("HH:mm") : ""}
                                                                  onChange={handleEndTimeChange}
                                                                  required
                                                                />
                                                              </div>
                                                            </div>
                                                          </form>
                                                        </div>

                                                        <div className="mt-4 flex justify-end gap-2">
                                                          <button
                                                            className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                            onClick={() => setOpen2(false)}
                                                          >
                                                            Anulează
                                                          </button>

                                                          <button
                                                            className={`btn ${isLoading
                                                              ? "bg-gray-500 text-gray-300"
                                                              : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                            onClick={handleButtonClick2}
                                                            disabled={isLoading}
                                                          >
                                                            {isLoading ? (
                                                              <svg
                                                                className="animate-spin fill-current shrink-0 xs:hidden"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                              >
                                                                <circle
                                                                  className="opacity-25"
                                                                  cx="8"
                                                                  cy="8"
                                                                  r="7"
                                                                  stroke="currentColor"
                                                                  strokeWidth="2" />
                                                                <path
                                                                  className="opacity-75"
                                                                  d="M12 2a6 6 0 000 12V2z" />
                                                              </svg>
                                                            ) : (
                                                              <svg
                                                                className="fill-current shrink-0 xs:hidden"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                              >
                                                                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                              </svg>
                                                            )}
                                                            <span className="//max-xs:sr-only">
                                                              {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                            </span>
                                                          </button>
                                                        </div>
                                                      </Dialog.Panel>
                                                    </Transition.Child>
                                                  </div>
                                                </div>
                                              </Dialog>
                                            </Transition>
                                          </IconButton>
                                        </Tooltip>
                                      </div>
                                    </td>
                                    <td className="p-2 whitespace-nowrap">{item.obiect_type_id === 1 ? userInst.user_name_surname || "-" : "-"}</td>
                                    <td className="p-2 whitespace-nowrap">{item.obiect_type_id === 1 ? userInst.spec || "-" : "-"}</td>
                                    <td className="p-2 whitespace-nowrap">{item.obiect_type_id === 1 ? userInst.inst : instCity.inst || "-"}</td>
                                    <td className="p-2 whitespace-nowrap">{item.obiect_type_id === 1 ? userAdres.adres : instCity.adres || "-"}</td>
                                    <td className="p-2 whitespace-nowrap">{item.obiect_type_id === 1 ? userCity.city_name : cityData.city_name || "-"}</td>
                                    <td className="p-2 whitespace-nowrap text-blue-500 underline cursor-pointer" onClick={() => setOpenRow(openRow === item.index ? null : item.index)}>Afiseaza</td>
                                    <td className="p-2 whitespace-nowrap text-blue-500 underline cursor-pointer" onClick={() => setOpenRow1(openRow1 === item.index ? null : item.index)}>Afiseaza</td>
                                    <td className="p-2 whitespace-nowrap text-blue-500 underline cursor-pointer" onClick={() => setOpenRow2(openRow2 === item.index ? null : item.index)}>Afiseaza</td>
                                    <td className="p-2 whitespace-nowrap text-blue-500 underline cursor-pointer" onClick={() => setOpenRow3(openRow3 === item.index ? null : item.index)}>Afiseaza</td>
                                    <td>
                                      <div
                                        className="font-semibold text-center"
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "20px",
                                        }}
                                      >
                                        <Tooltip title="Sterge" arrow placement="top">
                                          <IconButton
                                            onClick={() => setSelecteddeleteuser(item)}
                                            color="primary"
                                            sx={{
                                              fontSize: "16px",
                                              borderRadius: "50%",
                                              "&:hover": {
                                                backgroundColor: "#a4adad",
                                              },
                                            }}
                                          >
                                            <AiOutlineUserDelete className="dark:text-gray-100" />
                                          </IconButton>
                                        </Tooltip>
                                      </div>
                                    </td>
                                  </tr>
                                  {openRow === item.index && (
                                    <tr className="bg-gray-50 dark:bg-gray-800">
                                      <td colSpan="11" className="p-4">
                                        <div className="text-sm text-gray-800 dark:text-gray-200 flex justify-between">
                                          <div className="flex gap-1">
                                            <strong>Comentariu:</strong>
                                            <span style={{ width: '90%', display: 'block', wordWrap: 'break-word' }}>{item.comment || "Niciun comentariu"}</span>
                                          </div>
                                          <div className="flex-grow-0">
                                            <Tooltip title="Editeaza" arrow placement="top">
                                              <IconButton
                                                onClick={() => setSelecteddeleteuser2(item)}
                                                color="primary"
                                                sx={{
                                                  fontSize: "16px",
                                                  borderRadius: "50%",
                                                  "&:hover": {
                                                    backgroundColor: "#a4adad",
                                                  },
                                                }}
                                              >
                                                <AiFillEdit className="dark:text-gray-100" />
                                              </IconButton>
                                            </Tooltip>
                                          </div>
                                          <Transition appear show={open3} as={Fragment}>
                                            <Dialog as="div" className="relative z-10" onClose={() => setOpen3(false)}>
                                              <Transition.Child
                                                as={Fragment}
                                                enter="ease-out duration-300"
                                                enterFrom="opacity-0"
                                                enterTo="opacity-100"
                                                leave="ease-in duration-200"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                              >
                                                <div className="fixed inset-0 bg-black bg-opacity-25" />
                                              </Transition.Child>

                                              <div className="fixed inset-0 overflow-y-auto">
                                                <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                  <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0 scale-95"
                                                    enterTo="opacity-100 scale-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100 scale-100"
                                                    leaveTo="opacity-0 scale-95"
                                                  >
                                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                      <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900 dark:text-gray-200">
                                                        Comentariu
                                                      </Dialog.Title>
                                                      <div className="mt-4">
                                                        <textarea
                                                          id="message"
                                                          rows="4"
                                                          className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                          placeholder="Scrie aici..."
                                                          value={coment}
                                                          onChange={handleChangecom}
                                                        />
                                                      </div>

                                                      <div className="mt-4 flex justify-end gap-2">
                                                        <button
                                                          className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                          onClick={() => setOpen3(false)}
                                                        >
                                                          Anulează
                                                        </button>

                                                        <button
                                                          className={`btn ${isLoading
                                                            ? "bg-gray-500 text-gray-300"
                                                            : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                          onClick={handleButtonClick3}
                                                          disabled={isLoading}
                                                        >
                                                          {isLoading ? (
                                                            <svg
                                                              className="animate-spin fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <circle
                                                                className="opacity-25"
                                                                cx="8"
                                                                cy="8"
                                                                r="7"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                              />
                                                              <path
                                                                className="opacity-75"
                                                                d="M12 2a6 6 0 000 12V2z"
                                                              />
                                                            </svg>
                                                          ) : (
                                                            <svg
                                                              className="fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                            </svg>
                                                          )}
                                                          <span className="//max-xs:sr-only">
                                                            {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </Dialog.Panel>
                                                  </Transition.Child>
                                                </div>
                                              </div>
                                            </Dialog>
                                          </Transition>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                  {openRow1 === item.index && (
                                    <tr className="bg-gray-50 dark:bg-gray-800">

                                      <td colSpan="11" className="p-4">
                                        <div className="text-sm text-gray-800 dark:text-gray-200 flex justify-between">
                                          <div className="flex gap-1">
                                            <strong>Materiale:</strong>
                                            <span style={{ width: '90%', display: 'block', wordWrap: 'break-word' }}>
                                              {
                                                (() => {
                                                  const matchingInstCity = Data3.filter((i) => i.index === item.index).map((i) => i.materials_id);
                                                  const materialsFiltered = materials.filter((i) => matchingInstCity.includes(i.materials_id));

                                                  if (materialsFiltered.length > 0) {
                                                    return materialsFiltered.map((material) => material.description).join(", ");
                                                  }

                                                  return "Nu exista materiale";
                                                })()
                                              }
                                            </span>
                                          </div>
                                          <div className="flex-grow-0">
                                            <Tooltip title="Editeaza" arrow placement="top">
                                              <IconButton
                                                onClick={() => setSelecteddeleteuser3(item)}
                                                color="primary"
                                                sx={{
                                                  fontSize: "16px",
                                                  borderRadius: "50%",
                                                  "&:hover": {
                                                    backgroundColor: "#a4adad",
                                                  },
                                                }}
                                              >
                                                <AiFillEdit className="dark:text-gray-100" />
                                              </IconButton>
                                            </Tooltip>
                                          </div>
                                          <Transition appear show={open4} as={Fragment}>
                                            <Dialog as="div" className="relative z-10" onClose={() => setOpen4(false)}>
                                              <Transition.Child
                                                as={Fragment}
                                                enter="ease-out duration-300"
                                                enterFrom="opacity-0"
                                                enterTo="opacity-100"
                                                leave="ease-in duration-200"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                              >
                                                <div className="fixed inset-0 bg-black bg-opacity-25" />
                                              </Transition.Child>

                                              <div className="fixed inset-0 overflow-y-auto">
                                                <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                  <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0 scale-95"
                                                    enterTo="opacity-100 scale-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100 scale-100"
                                                    leaveTo="opacity-0 scale-95"
                                                  >
                                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                      <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900 dark:text-gray-200">
                                                        Materiale
                                                      </Dialog.Title>
                                                      <div className="relative mt-4">
                                                        <div className="w-full p-3  rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500">
                                                          <div className="space-y-2 mt-2">
                                                            {dropdownOptions1.map((option) => (
                                                              <div key={option.value} className="flex items-center">
                                                                <input
                                                                  type="checkbox"
                                                                  id={option.value}
                                                                  value={option.value}
                                                                  checked={defaultOption1.includes(option.value)} // Verifică dacă este selectat
                                                                  onChange={(e) => _onSelect1(option.value, e.target.checked)} // Gestionează selecția
                                                                  className="mr-2"
                                                                />
                                                                <label htmlFor={option.value} className="text-sm">{option.label}</label>
                                                              </div>
                                                            ))}
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="mt-4 flex justify-end gap-2">
                                                        <button
                                                          className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                          onClick={() => setOpen4(false)}
                                                        >
                                                          Anulează
                                                        </button>

                                                        <button
                                                          className={`btn ${isLoading
                                                            ? "bg-gray-500 text-gray-300"
                                                            : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                          onClick={handleButtonClick4}
                                                          disabled={isLoading}
                                                        >
                                                          {isLoading ? (
                                                            <svg
                                                              className="animate-spin fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <circle
                                                                className="opacity-25"
                                                                cx="8"
                                                                cy="8"
                                                                r="7"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                              />
                                                              <path
                                                                className="opacity-75"
                                                                d="M12 2a6 6 0 000 12V2z"
                                                              />
                                                            </svg>
                                                          ) : (
                                                            <svg
                                                              className="fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                            </svg>
                                                          )}
                                                          <span className="//max-xs:sr-only">
                                                            {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </Dialog.Panel>
                                                  </Transition.Child>
                                                </div>
                                              </div>
                                            </Dialog>
                                          </Transition>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                  {openRow2 === item.index && (
                                    <tr className="bg-gray-50 dark:bg-gray-800">
                                      <td colSpan="11" className="p-4">
                                        <div className="text-sm text-gray-800 dark:text-gray-200 flex justify-between">
                                          <div className="flex gap-1">
                                            <strong>Produse:</strong>
                                            <span style={{ width: '90%', display: 'block', wordWrap: 'break-word' }}>
                                              {
                                                (() => {
                                                  const matchingInstCity = Data4.filter((i) => i.index === item.index).map((i) => i.product_id);
                                                  const materialsFiltered = product.filter((i) => matchingInstCity.includes(i.product_id));
                                                  if (materialsFiltered.length > 0) {
                                                    return materialsFiltered.map((material) => material.description).join(", ");
                                                  }

                                                  return "Nu exista produse";
                                                })()
                                              }

                                            </span>
                                          </div>
                                          <div className="flex-grow-0">
                                            <IconButton
                                              onClick={() => setSelecteddeleteuser4(item)}
                                              color="primary"
                                              sx={{
                                                fontSize: "16px",
                                                borderRadius: "50%",
                                                "&:hover": {
                                                  backgroundColor: "#a4adad",
                                                },
                                              }}
                                            >
                                              <AiFillEdit className="dark:text-gray-100" />
                                            </IconButton>
                                          </div>
                                          <Transition appear show={open5} as={Fragment}>
                                            <Dialog as="div" className="relative z-10" onClose={() => setOpen5(false)}>
                                              <Transition.Child
                                                as={Fragment}
                                                enter="ease-out duration-300"
                                                enterFrom="opacity-0"
                                                enterTo="opacity-100"
                                                leave="ease-in duration-200"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                              >
                                                <div className="fixed inset-0 bg-black bg-opacity-25" />
                                              </Transition.Child>

                                              <div className="fixed inset-0 overflow-y-auto">
                                                <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                  <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0 scale-95"
                                                    enterTo="opacity-100 scale-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100 scale-100"
                                                    leaveTo="opacity-0 scale-95"
                                                  >
                                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                      <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900 dark:text-gray-200">
                                                        Produse
                                                      </Dialog.Title>
                                                      <div className="mt-4">
                                                        <input
                                                          type="text"
                                                          className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                                                          placeholder="Căutare Produs"
                                                          value={searchQuery2}
                                                          onChange={(e) => setSearchQuery2(e.target.value)} />
                                                      </div>

                                                      <div className="mt-4 max-h-64 overflow-y-auto">
                                                        <ul>
                                                          {product.filter((user) => {
                                                            return (
                                                              user.description.toLowerCase().includes(searchQuery2.toLowerCase())
                                                            );
                                                          }).map((user) => {
                                                            return (
                                                              <li key={user.product_id} className="flex items-center gap-2 p-2 border-b">
                                                                <input
                                                                  type="checkbox"
                                                                  className="h-4 w-4"
                                                                  checked={selectedUsers2.includes(user.product_id)}
                                                                  onChange={() => handleToggleUser2(user.product_id, "physician")} />
                                                                <div>
                                                                  <div className="pl-4 flex items-center justify-between">
                                                                    <h3 className="text-gray-900">{user.description}</h3>
                                                                  </div>
                                                                </div>
                                                              </li>
                                                            );
                                                          })}
                                                        </ul>
                                                      </div>


                                                      <div className="mt-4 flex justify-end gap-2">
                                                        <button
                                                          className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                          onClick={() => setOpen5(false)}
                                                        >
                                                          Anulează
                                                        </button>

                                                        <button
                                                          className={`btn ${isLoading
                                                            ? "bg-gray-500 text-gray-300"
                                                            : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                          onClick={handleButtonClick5}
                                                          disabled={isLoading}
                                                        >
                                                          {isLoading ? (
                                                            <svg
                                                              className="animate-spin fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <circle
                                                                className="opacity-25"
                                                                cx="8"
                                                                cy="8"
                                                                r="7"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                              />
                                                              <path
                                                                className="opacity-75"
                                                                d="M12 2a6 6 0 000 12V2z"
                                                              />
                                                            </svg>
                                                          ) : (
                                                            <svg
                                                              className="fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                            </svg>
                                                          )}
                                                          <span className="//max-xs:sr-only">
                                                            {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </Dialog.Panel>
                                                  </Transition.Child>
                                                </div>
                                              </div>
                                            </Dialog>
                                          </Transition>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                  {openRow3 === item.index && (
                                    <tr className="bg-gray-50 dark:bg-gray-800">
                                      <td colSpan="11" className="p-4">
                                        <div className="text-sm text-gray-800 dark:text-gray-200 flex justify-between">
                                          <div className="flex gap-1">
                                            <strong>User:</strong>
                                            <span style={{ width: '90%', display: 'block', wordWrap: 'break-word' }}>
                                              {
                                                (() => {
                                                  const matchingInstCity = Data5.filter((i) => i.index === item.index).map((i) => i.user_id);
                                                  const materialsFiltered = dropdownOptions.filter((i) => matchingInstCity.includes(i.value));
                                                  //////////////////////console.log(dropdownOptions)

                                                  if (materialsFiltered.length > 0) {
                                                    return materialsFiltered.map((material) => material.label).join(", ");
                                                  }

                                                  return "Nu exista user";
                                                })()
                                              }

                                            </span>
                                          </div>
                                          <div className="flex-grow-0">
                                            <IconButton
                                              onClick={() => setSelecteddeleteuser5(item)}
                                              color="primary"
                                              sx={{
                                                fontSize: "16px",
                                                borderRadius: "50%",
                                                "&:hover": {
                                                  backgroundColor: "#a4adad",
                                                },
                                              }}
                                            >
                                              <AiFillEdit className="dark:text-gray-100" />
                                            </IconButton>
                                          </div>
                                          <Transition appear show={open6} as={Fragment}>
                                            <Dialog as="div" className="relative z-10" onClose={() => setOpen6(false)}>
                                              <Transition.Child
                                                as={Fragment}
                                                enter="ease-out duration-300"
                                                enterFrom="opacity-0"
                                                enterTo="opacity-100"
                                                leave="ease-in duration-200"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                              >
                                                <div className="fixed inset-0 bg-black bg-opacity-25" />
                                              </Transition.Child>

                                              <div className="fixed inset-0 overflow-y-auto">
                                                <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                  <Transition.Child
                                                    as={Fragment}
                                                    enter="ease-out duration-300"
                                                    enterFrom="opacity-0 scale-95"
                                                    enterTo="opacity-100 scale-100"
                                                    leave="ease-in duration-200"
                                                    leaveFrom="opacity-100 scale-100"
                                                    leaveTo="opacity-0 scale-95"
                                                  >
                                                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                      <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900 dark:text-gray-200">
                                                        Useri
                                                      </Dialog.Title>
                                                      <div className="relative mt-4">
                                                        <div className="w-full p-3 rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500">
                                                          <div className="space-y-2 mt-2 max-h-[200px] overflow-y-auto">
                                                            {dropdownOptions.map((option) => (
                                                              <div key={option.value} className="flex items-center">
                                                                <input
                                                                  type="checkbox"
                                                                  id={option.value}
                                                                  value={option.value}
                                                                  checked={defaultOption2.includes(option.value)}
                                                                  onChange={(e) => _onSelect2(option.value, e.target.checked)}
                                                                  className="mr-2"
                                                                />
                                                                <label htmlFor={option.value} className="text-sm">{option.label}</label>
                                                              </div>
                                                            ))}
                                                          </div>
                                                        </div>
                                                      </div>


                                                      <div className="mt-4 flex justify-end gap-2">
                                                        <button
                                                          className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                          onClick={() => setOpen6(false)}
                                                        >
                                                          Anulează
                                                        </button>

                                                        <button
                                                          className={`btn ${isLoading
                                                            ? "bg-gray-500 text-gray-300"
                                                            : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                          onClick={handleButtonClick6}
                                                          disabled={isLoading}
                                                        >
                                                          {isLoading ? (
                                                            <svg
                                                              className="animate-spin fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <circle
                                                                className="opacity-25"
                                                                cx="8"
                                                                cy="8"
                                                                r="7"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                              />
                                                              <path
                                                                className="opacity-75"
                                                                d="M12 2a6 6 0 000 12V2z"
                                                              />
                                                            </svg>
                                                          ) : (
                                                            <svg
                                                              className="fill-current shrink-0 xs:hidden"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                            >
                                                              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                            </svg>
                                                          )}
                                                          <span className="//max-xs:sr-only">
                                                            {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                          </span>
                                                        </button>
                                                      </div>
                                                    </Dialog.Panel>
                                                  </Transition.Child>
                                                </div>
                                              </div>
                                            </Dialog>
                                          </Transition>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {currentItems1.length > 5 && (
                    <div className="flex justify-center mt-4">
                      <button
                        onClick={() => setCurrentPage1((prev) => Math.max(prev - 1, 1))}
                        className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                        disabled={currentPage1 === 1}
                      >
                        Prev
                      </button>

                      {currentPage1 > 3 && (
                        <>
                          <button
                            onClick={() => setCurrentPage1(1)}
                            className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                          >
                            1
                          </button>
                          <span className="px-2">...</span>
                        </>
                      )}

                      {Array.from({ length: totalPages1 }, (_, index) => {
                        const page = index + 1;

                        if (
                          page === currentPage1 ||
                          // page === 1 ||
                          // page === totalPages ||
                          (page >= currentPage1 - 1 && page <= currentPage1 + 1)
                        ) {
                          return (
                            <button
                              key={page}
                              onClick={() => setCurrentPage1(page)}
                              className={`px-4 py-2 text-sm font-medium ${currentPage1 === page
                                ? "bg-gray-500 text-white"
                                : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                }`}
                            >
                              {page}
                            </button>
                          );
                        }
                        return null;
                      })}

                      {currentPage1 < totalPages1 - 2 && (
                        <>
                          <span className="px-2">...</span>
                          <button
                            onClick={() => setCurrentPage1(totalPages1)}
                            className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                          >
                            {totalPages1}
                          </button>
                        </>
                      )}

                      <button
                        onClick={() =>
                          setCurrentPage1((prev) => Math.min(prev + 1, totalPages1))
                        }
                        className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                        disabled={currentPage1 === totalPages1}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </CardContent>
              <Divider className="dark:bg-gray-400" />
              <CardActions sx={{ justifyContent: 'flex-end' }}>
                <button
                  className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white flex items-center gap-2"
                  onClick={handleSubmit}
                  disabled={loading} // Dezactivează când se încarcă
                >
                  {loading ? (
                    <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                    </svg>
                  ) : (
                    <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                      <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                    </svg>
                  )}
                  <span className="//max-xs:sr-only">{loading ? "Se salvează..." : "Salvează detaliile"}</span>
                </button>
              </CardActions>
            </Card>
          </form>
        </div>
      )}
    </div>
  );
}

export default DashboardCard24copy;